import incCount from '../helpers/incCount';
import orderBy from 'lodash/orderBy';
import stringIsEqual from '../helpers/stringIsEqual';

export default function createFacet(_config, state) {
  return {
    // Define the state that is used for filtering the products before reducing to individual values.
    state: { ...state, productTypes: [] },

    // The reducer for the facet values.
    reducer: (productTypes, product) => {
      const color = incCount(productTypes, product.wineColor);
      const wineType = incCount(color, product.wineType);
      const productType = incCount(wineType, product.productType);
      return productType;
    },

    // The initial value for the reducer.
    // If a filter is set on the productTypes: keep that value in the facets even with 0 results.
    initialValue: state.productTypes.reduce((initialValue, productType) => {
      initialValue[productType] = 0;
      return initialValue;
    }, {}),

    // Sort and group the facets before displaying them.
    prepare: (facetValues) => {
      return orderBy(
        Object.entries(facetValues)
          .filter(([value]) => Boolean(value))
          .map(([value, count]) => ({ value, count })),
        'count',
        'desc'
      );
    },

    // Tests if a product matches a certain filter.
    matches:
      ({ productTypes }) =>
      (product) => {
        if (!productTypes || productTypes.length === 0) return true;
        return productTypes.some(
          (productType) =>
            stringIsEqual(product.wineColor, productType) ||
            stringIsEqual(product.wineType, productType) ||
            stringIsEqual(product.productType, productType)
        );
      },
  };
}
